import React, { useMemo, useState } from 'react';

import { availabilityPickerContext } from '.';
import { AvailabilityPopup } from 'src/components/availability/AvailabilityPopup';

export function AvailabilityPickerProvider({ children }: React.PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false);

    const value = useMemo(
        () => ({
            setOpen: setIsOpen,
            isOpen,
        }),
        [isOpen]
    );

    return (
        <availabilityPickerContext.Provider value={value}>
            {children}
            <AvailabilityPopup isOpen={isOpen} setOpen={setIsOpen} />
        </availabilityPickerContext.Provider>
    );
}
